<template>
    <div class="row">
      <loader v-if="!isLoaded"></loader>
      <stage-header v-if="protocolVuexData" :stage="stage" :protocolsData="protocolVuexData" :stageCount="stageCount" v-on:close-session="closeSession" v-on:fetch-protocol="fetchProtocolData"/>

      <div class="mb-4" :class="{
        'col-md-3': phasesCount == 4,
        'col-md-4': phasesCount == 3,
        'col-md-6': phasesCount == 2 || phasesCount == 1,
      }" v-if="mastering">
        <router-link
            class="link-box link-box_red"
            :to="{ name: 'mastering-stage', params: {stageId: this.stageId, phaseId: 1, protocolData:protocolVuexData, client:client, stage: stage}}">
          <h4 class="link-box__title">{{'protocol.mastering' | trans}}</h4>
        </router-link>
      </div>
      <div class="mb-4" :class="{
        'col-md-3': phasesCount == 4,
        'col-md-4': phasesCount == 3,
        'col-md-6': phasesCount == 2 || phasesCount == 1,
      }" v-if="rotation">
        <router-link
            class="link-box link-box_orange"
            v-if="rotationCount"
            :to="{ name: 'rotation-stage', params: {stageId: this.stageId, phaseId: 2, protocolData:protocolVuexData, client:client, stage: stage}}">
          <h4 class="link-box__title">{{'protocol.rotation' | trans}}</h4>
        </router-link>
        <div class="link-box link-box_orange disabled" v-if="!rotationCount">
          <h4 class="link-box__title">{{'protocol.rotation' | trans}}</h4>
        </div>
      </div>
      <div class="mb-4" :class="{
        'col-md-3': phasesCount == 4,
        'col-md-4': phasesCount == 3,
        'col-md-6': phasesCount == 2 || phasesCount == 1,
      }" v-if="fluency">
        <router-link
            class="link-box link-box_light-green"
            v-if="fluencyCount"
            :to="{ name: 'fluency-stage', params: {stageId: this.stageId, phaseId: 4, protocolData:protocolVuexData, client:client, stage: stage}}">
          <h4 class="link-box__title">{{'protocol.fluency' | trans}}</h4>
        </router-link>
        <div class="link-box link-box_orange disabled"  v-if="!fluencyCount">
          <h4 class="link-box__title">{{'protocol.fluency' | trans}}</h4>
        </div>
      </div>
      <div class="mb-4" :class="{
        'col-md-3': phasesCount == 4,
        'col-md-4': phasesCount == 3,
        'col-md-6': phasesCount == 2 || phasesCount == 1,
      }" v-if="support">
        
        <router-link
            v-if="supportCount"
            class="link-box link-box_green"
            :to="{ name: 'maintain-stage', params: {stageId: this.stageId, phaseId: 3, client:client, stage: stage, teachingMethod: 1}}">
          <h4 class="link-box__title">{{'protocol.support' | trans}}</h4>
        </router-link>
        <div class="link-box link-box_orange disabled"  v-if="!supportCount">
          <h4 class="link-box__title">{{'protocol.support' | trans}}</h4>
        </div>
      </div>

      <div class="col-md-12">
        <router-view/>
      </div>

      <div class="col-md-12 form-group-button stage-button" v-if="stageCount > 1">

        <router-link class="btn btn-primary btn-sm mr-2"
                     :to="{ name: 'stage-list', params: {clientId: clientId, protocolData: protocolVuexData, teachingMethod: 1, stage: stage }}">
          <span>Вернуться к списку этапов</span>
        </router-link>

      </div>

      <mdc-dialog v-model="isModalVisible"
                  :title="title"
                  :accept="'protocol.buttons.finishCurrentStage' | trans"
                  :cancel="'user.cancel' | trans"
                  @accept="closeStage"
                  @cancel="onModalClose">
      </mdc-dialog>
    </div>

</template>

<script>
  import axios from 'axios';
  import {mapGetters, mapState, mapActions} from 'vuex';
  import {PROTOCOL_STATUSES} from '../../protocols/constants.js';
  import round from 'lodash/round';
  import filter from 'lodash/filter';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';
  import StageHeader from './StageHeader'

  export default {
    components: {Loader, StageHeader},
    name: 'ChoseStage',
    props: {
      'name': null,
      'clientData': null,
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },

      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/assigned/dtt/',
        apiClientUrl: '/users/clients/',
        protocol: null,
        mastering: null,
        rotation: null,
        fluency: null,
        support: null,
        rotationCount: null,
        fluencyCount: null,
        supportCount: null,
        client: {},
        assignedProtocolId: null,
        loaded: false,
        phasesCount: null,
        isModalVisible:false,
        isLoaded: false,
        title: lang.get('protocol.confirm_close'),
        stage: null
      };
    },
    created() {
      this.fetchProtocolData();
    },

    computed: {
      ...mapState([
        'route',
      ]),
      ...mapGetters('auth', [
        'isBCBA',
        'isCurator',
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),

      stageCount(){
        let activeList = this.protocolVuexData && this.protocolVuexData.protocol.stages ? filter(this.protocolVuexData.protocol.stages, stage => !stage.isClosed).length : 0;

        return activeList;
      }

    },
    methods: {

      ...mapActions('protocol', [
        'setProtocol',
        'setProtocolVersion',
      ]),


      fetchProtocolData: async function() {
        try {
          this.isLoaded = false;
          let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);
          this.stage = response.data.data;
          this.assignedProtocolId = response.data.data.assigneeId;
          this.client = this.clientData;
          if (response) {
            let phases = this.stage.phases;
            this.mastering = filter(phases, function(item) {
              return item.typeId == 1;
            })[0];
            this.rotation = filter(phases, function(item) {
              return item.typeId == 2;
            })[0];
            this.rotationCount = this.rotation ? this.rotation.taskCount : null;
            this.fluency = filter(phases, function(item) {
              return item.typeId == 4;
            })[0]
            this.fluencyCount = this.fluency ? this.fluency.taskCount : null;
            this.support = filter(phases, function(item) {
              return item.typeId == 3;
            })[0];
            this.supportCount = this.support ? this.support.taskCount : null;
            this.phasesCount = phases ? phases.length : 0;

            this.isLoaded = true;
          }
        } catch (error) {
          console.dir(error);
          if (error.status == 403) {
            this.$router.push({name: 'client'});
          } else {
            this.$router.push({name: 'error'});
          }
        }

      },

      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        } finally {
          this.loaded = true
        }
      },
      backToPreviousPage() {
        if (this.clientId || this.assignedProtocolId) {
          this.$router.push({name: 'stage-list', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
        }
        else {
          this.$router.push({name: 'protocols'});
        }
      },
      closeSession: function() {
        let stageActiveList = filter(this.protocolVuexData.protocol.stages, ['isClosed', false]);
        if (stageActiveList.length == 1){
          this.title = lang.get('protocol.confirm_close_all')
        }
        this.isModalVisible = true
      },
      onModalClose () {
        this.isModalVisible = false
      },

      async closeStage() {
        let isSaved;
        this.isLoaded = false;

        let sessionDate = null;
        let timeSessionDate = null;
        let timeSessionEndDate = null;

        if (this.isPreviousDateSession && this.previousTime.HH) {
          let clientTimeZoneOffset = moment().tz(this.clientData.timezone)._offset;
          sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
            this.previousDate.getMonth(),
            this.previousDate.getDate(),
            this.previousTime.HH,
            this.previousTime.mm));

          timeSessionDate = moment(sessionDate).unix() -
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          timeSessionEndDate = moment(sessionDate).unix() +
              this.previousDuration * Constants.SECONDS_PER_MINUTE -
              (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
        }
        
        isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
            {
              'assignedSessions': [
                {
                  'uuid': UuidGenerator.v4(),
                  'startedAt': this.isPreviousDateSession ?
                      timeSessionDate : Math.round((new Date()).getTime() / 1000), //
                  'finishedAt': this.isPreviousDateSession ?
                      timeSessionEndDate :
                      Math.round((new Date()).getTime() / 1000), //
                }
              ],
              'uuid': this.stage.uuid,
              'majorVersion': this.protocolVuexData.protocol.majorVersion,
              'close': true
            }).then(response => {
              let stageActiveList = filter(this.protocolVuexData.protocol.stages, ['isClosed', false]);
              this.setProtocol(null);
              if (stageActiveList.length <= 1){
                this.$router.push({name: 'results', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
              } else{
                this.$router.push({name: 'stage-list', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
              }
              //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});

            }).catch(error => {
              console.info(error)
              this.isLoaded = true;
            });
      }

    }
    
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ChooseStage.vue